(function() {
  var originalParent;
  var originalNextSibling;

  function placeReviewsInHero() {
    var reviews = document.getElementById('shopify-section-1601287440633');
    var heroContent = document.querySelector('#Hero-hero-1 .hero__inner .page-width');

    if (!reviews || !heroContent) {
      return;
    }

    if (!originalParent) {
      originalParent = reviews.parentNode;
      originalNextSibling = reviews.nextSibling;
    }

    if (window.matchMedia('(max-width: 749px)').matches) {
      reviews.classList.remove('hero-reviews');
      if (reviews.parentNode !== originalParent) {
        originalParent.insertBefore(reviews, originalNextSibling);
      }
    } else if (reviews.parentNode !== heroContent) {
      reviews.classList.add('hero-reviews');
      heroContent.appendChild(reviews);
    }
  }

  document.addEventListener('DOMContentLoaded', placeReviewsInHero);
  document.addEventListener('shopify:section:load', placeReviewsInHero);
  window.addEventListener('resize', placeReviewsInHero);
})();
